<template>
  <el-card
    v-if="marketInfo.status == 'approved'"
    class="forms-containers"
    style="padding: 16px;"
    shadow="never"
  >
    <el-alert
      style="margin-bottom: 16px;"
      type="success"
      title="开通商店申请已通过"
    ></el-alert>
    <label-item label="商店名称" :value="marketInfo.name"></label-item>
    <label-item label="审批意见" :value="marketInfo.note"></label-item>
    <label-item
      label="商店地址"
      :value="getMarketURL(marketInfo.domain)"
      :href="getMarketURL(marketInfo.domain)"
      target="_blank"
    ></label-item>
  </el-card>
  <el-card
    v-else
    class="forms-containers"
    style="padding: 16px;"
    shadow="never"
  >
    <el-alert
      v-if="marketInfo.status == 'pending'"
      style="margin-bottom: 16px;"
      type="success"
      title="你的申请正在审核中，你可以继续修改申请信息"
    ></el-alert>
    <el-alert
      v-if="marketInfo.status == 'rejected'"
      style="margin-bottom: 16px;"
      type="warning"
      title="你的申请已被拒绝，你可以继续修改申请信息"
    ></el-alert>
    <el-form
      v-if="enterprise.verify"
      ref="form"
      :model="marketInfo"
      label-width="120px"
      :rules="rules"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item prop="name" label="商店名称">
            <el-input v-model="marketInfo.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="domain" label="商店域">
            <el-input v-model="marketInfo.domain"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item prop="contactName" label="联系人">
            <el-input v-model="marketInfo.contactName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="contactPhone" label="联系电话">
            <el-input v-model="marketInfo.contactPhone"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item prop="description" label="商店简介">
            <el-input
              type="textarea"
              v-model="marketInfo.description"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="marketlogo" prop="logo" label="商店LOGO">
            <el-upload
              v-loading="uploadImageLoading"
              class="avatar-uploader"
              :action="uploadConfig.api"
              :with-credentials="true"
              :headers="uploadConfig.headers"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :on-error="handleAvatarError"
              :before-upload="beforeAvatarUpload"
            >
              <el-avatar
                v-loading="uploadImageLoading"
                class="logoImage"
                v-if="marketInfo.logo && marketInfo.logo.length>0"
                shape="square"
                fit="fill"
                :src="marketInfo.logo"
              ></el-avatar>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span style="color: #999999; font-size: 12px;">
              请上传 150*50 规格的PNG图片
            </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-button
          v-if="marketInfo.status == ''"
          type="primary"
          style="margin-left: 120px;"
          @click="commit"
          >提交申请</el-button
        >
        <el-button
          v-else
          type="primary"
          style="margin-left: 120px;"
          @click="commit"
          >更新申请</el-button
        >
      </el-row>
    </el-form>
    <div v-else>
      <el-alert
        title="企业未完成实名认证，不能开通商店"
        type="warning"
        show-icon
      ></el-alert>
      <div style="padding: 16px;">
        <router-link
          type="button"
          :to="{ name: 'basic', query: { tab: 'auth' } }"
          >去认证</router-link
        >
      </div>
    </div>
  </el-card>
</template>
<script>
import { getToken } from '@/utils/auth';
import { errorHandle } from '@/utils/error';
import {
  openMarket,
  getOpenMarketRecoder,
  updateOpenMarket
} from '@/api/appStore';
export default {
  name: 'OpenMarket',
  data() {
    var baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    return {
      Loading: true,
      uploadImageLoading: false,
      activeName: 'detail',
      marketInfo: {
        status: '',
        nmae: '',
        description: '商店由Rainstore驱动，支持应用SaaS化销售。',
        domain: '',
        contactName: '',
        contactPhone: '',
        contactEmail: ''
      },
      uploadConfig: {
        api: `${baseDomain}/app-server/uploads/picture`,
        headers: {
          Authorization: getToken()
        }
      },
      rules: {
        name: [
          { required: true, message: '商店名称是必填', trigger: 'blur' },
          {
            min: 2,
            max: 12,
            message: '商店名称字符在2-12之间',
            trigger: 'blur'
          }
        ],
        domain: [
          { required: true, message: '商店域是必填', trigger: 'blur' },
          {
            min: 4,
            max: 32,
            message: '商店域字符在4-32之间',
            trigger: 'blur'
          },
          {
            pattern: /^[A-Za-z]+$/,
            message: '商店域只能由英文字母组成',
            trigger: 'blur'
          }
        ],
        contactName: [
          { required: true, message: '联系人是必填', trigger: 'blur' },
          {
            min: 2,
            max: 255,
            message: '联系人名称字符在2-255之间',
            trigger: 'blur'
          }
        ],
        contactPhone: [
          { required: true, message: '联系电话是必填', trigger: 'blur' },
          { min: 7, max: 12, message: '联系电话只能是7-12位，由数字和-组成', trigger: 'blur' },
          {
            pattern: /^[0-9-]+$/,
            message: '联系电话只能是7-12位，由数字和-组成',
            trigger: 'blur'
          }
        ],
        description: [
          {
            max: 255,
            message: '商店简介字符数在255以内',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {
    this.getOpenMarketRecoder();
    this.marketInfo = {
      name: this.enterprise.name + '的商店',
      contactName: this.enterprise.contactName,
      contactPhone: this.enterprise.contactPhone,
      status: ''
    };
  },
  computed: {
    sidebar() {
      return this.$store.state;
    },
    enterprise() {
      return this.$store.state.enterprise.enterpriseInfo;
    }
  },
  methods: {
    getMarketURL(doamin) {
      const href = window.location.href;
      const domains = href.split('/').slice(0, 3).join('/');
      return `${domains}/markets/${doamin}`;
    },
    getOpenMarketRecoder() {
      getOpenMarketRecoder(this.enterprise.eid)
        .then((re) => {
          if (re && re.status) {
            this.marketInfo = re;
          }
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    commit() {
      const formName = 'form';
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.marketInfo.status) {
            updateOpenMarket(this.marketInfo)
              .then((re) => {
                this.$message.success('更新成功');
                this.marketInfo = re;
              })
              .catch((err) => {
                if (err.code == 10000) {
                  this.$message.warning('已经申请过了，请等待审核');
                }
                errorHandle(err);
              });
          } else {
            openMarket(this.marketInfo)
              .then((re) => {
                this.$message.success('申请成功');
                this.marketInfo = re;
              })
              .catch((err) => {
                if (err.code == 10000) {
                  this.$message.warning('已经申请过了，请等待审核');
                }
                errorHandle(err);
              });
          }
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.marketInfo.logo = res.FileURL;
      this.uploadImageLoading = false;
    },
    handleAvatarError(re) {
      if (re.code == 10024) {
        this.$message.error(
          '上传图片类型不支持，请上传以.png .jpg .jpeg 结尾的图片'
        );
        return;
      }
      this.$message.error('上传失败!');
      this.uploadImageLoading = false;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        this.$message.error('上传头像图片只能是 JPG、PNG格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      const canUpload = (isJPG || isPng) && isLt2M;
      if (canUpload) {
        this.uploadImageLoading = true;
      }
      return canUpload;
    },
    beforeAvatarUploadpic(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        return this.$message.error('上传图片只能是 JPG、PNG格式!');
      }
      if (!isLt2M) {
        return this.$message.error('上传图片大小不能超过 2MB!');
      }

      return (isJPG || isPng) && isLt2M;
    }
  }
};
</script>
<style lang="scss" scoped>
.avatar-uploader {
  width: 150px;
  height: 50px;
  border-radius: 10px;
  border: 2px dashed #f0f0f0;
}
::v-deep .avatar-uploader .el-upload {
  line-height: 50px;
  width: 150px;
}
::v-deep .logoImage {
  width: 150px;
  height: 50px;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/information/openmarket/index.vue